import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useFireStore } from '../../firebase/firebase'
import { usePosition } from 'use-position';
import { AppState } from 'App';
import { useAuth } from 'context/AuthContext'


import HomeView from 'components/ui/HomeView'

export default function Home() {

    const {t, i18n} = useTranslation('common');
    const [appState, setAppState] = useContext(AppState)

    const stepStyle = {
    ...appState.isMapDark ? {
        color: '#AFB3B9',
        background: '#242526',
        border: '1px solid #424242'}
        : {
        color: '#65676B',
        background: '#ffffff',
        border: '1px solid #F0F0F0'}
    };

    const steps = [
        {
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading1')}{' '}{appState.username}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour1')}</p>

                </div>),
            style: stepStyle
        },
        {
            selector: '#first',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading2')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour2')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#second',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading3')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour3')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#third',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading4')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour4')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#fourth',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading5')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour5')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#fifth',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading6')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour6')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#tour14',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading7')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour7')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#photo14',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading75')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour75')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#seventh',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading8')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour8')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#walks',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading9')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour9')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#toured14',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading10')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour10')}</p>
                </div>),
            style: stepStyle
        },
        {
            selector: '#eighth',
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading11')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour11')}</p>
                </div>),
            style: stepStyle
        },
        {
            content: () => (
                <div>
                    <h2 className="text-xl text-textlight dark:text-textdark">{t('Tour1Heading12')}</h2>
                    <p className="mt-4 text-base font-light dark:text-textdarkfeature text-textlightfeature">{t('Tour12')}</p>
                </div>),
            style: stepStyle
        },
    ];

    const { currentUser } = useAuth()
    const { latitude, longitude } = usePosition();

    // state for the query results
    const [posts, setPosts] = useState([])
    const [tags, setTags] = useState([])
    const [coords, setCoords] = useState([])
    const [dates, setDates] = useState([])
    const [icons, setIcons] = useState(null)
    const [latestNumber, setLatestNumber] = useState([])
    const [tagCounts, setTagCounts] = useState({})

    const test = JSON.parse(localStorage.getItem("tour"));
    const [doTour, setDoTour] = useState(test)

    async function Initialise() {

        setAppState(prevState => ({...prevState,loadingContext:true}))

        let query = useFireStore.collection('posts').where("user","==",`${currentUser.uid}`).orderBy('order', 'desc')

        if (appState.tagContext !== null) {
            query = query.where("tag", "==", `${appState.tagContext}`)
        }
        if (appState.dateContext !== null) {
            query = useFireStore.collection('posts').where("date", "==", `${appState.dateContext}`).where("user","==",`${currentUser.uid}`)
        }
        if (appState.favouriteContext !== null) {
            query = useFireStore.collection('posts').where("liked", "==", true).where("user","==",`${currentUser.uid}`).orderBy('order', 'desc')
        }
        if (appState.latitude !== null) {
            query = useFireStore.collection('posts').where("latitude", "==", appState.latitude).where("longitude", "==", appState.longitude).where("user","==",`${currentUser.uid}`).orderBy('order', 'desc')
        }

        const unsubscribe = await query.onSnapshot(snapshot => {

            let postData = [];
            snapshot.forEach(doc => {
                postData.push({...doc.data(), id: doc.id })
            });
            setPosts(postData)
            //setPosts(posts => posts.concat(postData))

            // GET TAGS
            let tagData = [];
            snapshot.forEach(doc => {
                tagData.push(doc.data().tag)
            });
            setTags([...new Set(tagData)]);

            // GET A COUNT OF THE NUMBER OF UNIQUE TAGS
            var uniqs = tagData.reduce((acc, val) => {
                acc[val] = acc[val] === undefined ? 1 : acc[val] += 1;
                return acc;
            }, {});
            setTagCounts(uniqs)

            // MAP DATA
            const newArray = []
            snapshot.forEach(doc => {
                newArray.push([doc.data().latitude, doc.data().longitude]);
            })
            setCoords(newArray)

            // GET DATA FOR THE CALENDAR
            let dateData = []
            snapshot.forEach(doc => {
                dateData.push(doc.data().date)
            });
            setDates([...new Set(dateData)]);

            // GET ORDER NUMBERS
            let orderNos = []
            snapshot.forEach(doc => {
                orderNos.push(doc.data().order)
                setLatestNumber(orderNos)
            })


            setAppState(prevState => ({...prevState,loadingContext:null}))
            //latestDoc = snapshot.docs[snapshot.docs.length - 1];
            //console.log("latestDoc: ",latestDoc)
        })
        return () => unsubscribe();

    }

    useEffect(() => {
        Initialise();
    },[appState.tagContext, appState.dateContext, appState.favouriteContext, appState.latitude, appState.longitude])

    async function getUserData() {
        let userData = useFireStore.collection('users').doc(currentUser.uid)
        await userData.get().then(res => {
            setAppState(prevState => ({
                ...prevState,
                username:res.data().username,
                userPhoto:res.data().profilePhotoUrl,
                newUser:res.data().newUser
            }))
        })
    }

    async function fetchIcons() {
        let getIcons = useFireStore.collection('tagIcons').doc(currentUser.uid)

        const unsub = await getIcons.onSnapshot(docSnapshot => {
            setIcons(docSnapshot.data());  // CHANGE THIS TO APP.STATE AFTER CHECKING EVERYTHING WORKS - CANT REMEMBER WHY HAHA
        })
        return () => unsub();
    }

    useEffect(() => {
        fetchIcons();
        if (appState.newUser!==true) {
            getUserData();
        }
    },[])

    useEffect(() => {
        const newNos = Math.max(...latestNumber)
        setAppState(prevState => ({...prevState,currentPost:newNos}))
    },[latestNumber])

    return (
        <>
        <HomeView
            tags={tags}
            icons={icons}
            latitude={latitude}
            longitude={longitude}
            tagCounts={tagCounts}
            coords={coords}
            dates={dates}
            posts={posts}
            icons={icons}
            doTour={doTour}
            steps={steps}
        />
        </>
    )
}